import React from 'react';
import { Tag } from 'core/components';

const ICON_MAP = {
  success: 'tick',
  warning: 'warning-sign',
  danger: 'error',
  none: 'circle'
};

const GeneralIndicator = ({ intent = 'none', text, title }) => {
  const fontWeight = intent === 'none' ? 'normal' : 'bold';
  const icon = ICON_MAP[intent];
  const iconProps = intent === 'none' ? { iconSize: 9 } : { iconSize: 14 };

  return (
    <Tag intent={intent} icon={icon} iconProps={iconProps} minimal fontWeight={fontWeight} title={title}>
      {text}
    </Tag>
  );
};
export default GeneralIndicator;
